import React, { useState, useEffect } from 'react';
import {
  Box,
  TextField,
  Button,
  Paper,
  Typography,
  Alert,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Container,
} from '@mui/material';
import { authAPI } from '../../services/api';
import { authService } from '../../services/auth';

const LoginForm = ({ onLoginSuccess }) => {
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    server: 'https://blade.pilot-gps.com',
  });
  
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [availableServers, setAvailableServers] = useState([
    'https://blade.pilot-gps.com',
    'https://pilot-gps.com',
  ]);

  useEffect(() => {
    // Можно загрузить список серверов из бэкенда
    // Пока используем хардкод
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
    if (error) setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      console.log('🔐 Отправка запроса авторизации...', {
        username: formData.username,
        server: formData.server,
      });

      const response = await authAPI.login(formData);
      
      console.log('📥 Ответ от сервера:', response.data);

      if (response.data.success) {
        // Сохраняем данные авторизации
        authService.login(response.data.token, response.data.user);
        
        console.log('✅ Авторизация успешна!', {
          user: response.data.user,
          token: response.data.token.substring(0, 20) + '...',
        });

        // Сохраняем выбранный сервер
        localStorage.setItem('last_server', formData.server);
        
        // Вызываем колбэк
        if (onLoginSuccess) {
          onLoginSuccess(response.data.user);
        }
      } else {
        setError(response.data.message || 'Ошибка авторизации');
      }
    } catch (err) {
      console.error('❌ Ошибка при авторизации:', err);
      
      if (err.response?.data?.message) {
        setError(err.response.data.message);
      } else if (err.message.includes('Network Error')) {
        setError('Не удалось подключиться к серверу. Проверьте подключение к интернету.');
      } else if (err.response?.status === 401) {
        setError('Неверное имя пользователя или пароль');
      } else if (err.response?.status === 503) {
        setError('Система мониторинга недоступна. Попробуйте позже.');
      } else {
        setError('Произошла ошибка при авторизации');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Paper
          elevation={3}
          sx={{
            padding: 4,
            width: '100%',
            maxWidth: 400,
            borderRadius: 2,
          }}
        >
          <Typography component="h1" variant="h5" align="center" gutterBottom>
            Вход в систему рейтингов
          </Typography>
          
          <Typography variant="body2" color="text.secondary" align="center" sx={{ mb: 3 }}>
            Введите учетные данные от системы Pilot-GPS
          </Typography>

          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          <form onSubmit={handleSubmit}>
            <FormControl fullWidth margin="normal">
              <InputLabel id="server-label">Сервер</InputLabel>
              <Select
                labelId="server-label"
                name="server"
                value={formData.server}
                label="Сервер"
                onChange={handleChange}
                required
              >
                {availableServers.map((server) => (
                  <MenuItem key={server} value={server}>
                    {server}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <TextField
              margin="normal"
              required
              fullWidth
              id="username"
              label="Логин"
              name="username"
              autoComplete="username"
              autoFocus
              value={formData.username}
              onChange={handleChange}
              disabled={loading}
            />

            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Пароль"
              type="password"
              id="password"
              autoComplete="current-password"
              value={formData.password}
              onChange={handleChange}
              disabled={loading}
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              disabled={loading}
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                'Войти'
              )}
            </Button>

            <Typography variant="caption" display="block" color="text.secondary" align="center">
              Для тестирования используйте:<br />
              Логин: ngm_service_ooopv<br />
              Пароль: Ngm_service_ooopv_1
            </Typography>
          </form>
        </Paper>
      </Box>
    </Container>
  );
};

export default LoginForm;
